// @flow

import { type Users } from '@vimcar/shared-stores/mobx/users'
import { viewModel, type Params } from '@vimcar/shared-utils/bindViewModel'

import i18n from '#utils/i18n'

const tp = i18n.prefix('components.TimezonePreferences')

type TimezoneOption = {|
  zone: string,
  label: string,
|}

type Models = {|
  users: Users,
|}

export default (_: any, { getGlobal, mkSubscriber }: Params) => {
  const { users }: Models = getGlobal('models')
  const vm = viewModel({
    updateZoneinfo$: mkSubscriber(),

    get currentTimezone(): ?string {
      return users.optionalSelf.get().zoneinfo || null
    },

    handleTimezoneChange: (_: any, value: string) => {
      vm.updateZoneinfo$.set(
        users.optionalSelf.get().update({ zoneinfo: value })
      )
    },

    timezoneOptions: ([{
      label: tp('zone-berlin'),
      zone: 'Europe/Berlin',
    }, {
      label: tp('zone-london'),
      zone: 'Europe/London',
    }]: Array<TimezoneOption>),
  })

  return vm
}
